import {
	Component,
	ContentChildren,
	Input,
	QueryList
} from '@angular/core';
import { BreadCrumbItemViewComponent } from './breadcrumb-item-view/breadcrumb-item-view.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'breadcrumb-layout',
	host: {
		'[attr.aria-label]': 'ariaLabel',
		'role': 'navigation'
	},
	templateUrl: './breadcrumb-layout.component.html',
	styleUrls: ['./breadcrumb-layout.component.scss'],
	standalone: false
})

export class BreadCrumbLayoutComponent {
	@Input() public showMobileBackButton = true;
	public ariaLabel: string;

	@ContentChildren(BreadCrumbItemViewComponent, {
		descendants: true
	}) public items: QueryList<BreadCrumbItemViewComponent>;

	constructor (private readonly translate: TranslateService) {
		this.ariaLabel = this.translate.instant('common_breadcrumb');
	}

	public onBack () {
		const length = this.items.length;
		this.items.get(length - 2).action.emit();
	}
}
